import React from "react";
import {Result, Typography} from "antd";

interface Props {
    extra?: React.ReactNode
}

const Error403 = ({extra}: Props) => {
    return (
        <Result
            status="403"
            title="403"
            subTitle={<p>Sorry, you are not authorized to access this page. Please contact <Typography.Link href='mailto:rio@sfu.ca'>rio@sfu.ca</Typography.Link> for more information.</p>}
            extra={extra}
        />
    )
};

export default Error403;